import { useState } from 'react'
import { ExternalLink } from 'lucide-react'
import { CookiePreferences } from '@/components/CookiePreferences'

export function DashboardFooter() {
  const [prefsOpen, setPrefsOpen] = useState(false)

  const links = [
    { label: 'Privacy', href: 'https://purpletoadmail.com/privacy' },
    { label: 'Terms', href: 'https://purpletoadmail.com/terms' },
    { label: 'AUP', href: 'https://purpletoadmail.com/aup' },
    { label: 'Contact', href: 'mailto:hello@purpletoadmail.com' },
    { label: 'Support', href: 'mailto:hello@purpletoadmail.com' },
    { label: 'Status', href: 'https://status.purpletoadmail.com' },
  ]

  return (
    <footer className="border-t bg-background/50 px-4 py-6 mt-auto">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 sm:flex-row">
        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1">
          {links.map((link) => (
            <a
              key={link.label}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-muted-foreground hover:text-foreground flex items-center gap-0.5"
            >
              {link.label}
              <ExternalLink className="h-3 w-3" />
            </a>
          ))}
          <button
            onClick={() => setPrefsOpen(true)}
            className="text-xs text-muted-foreground hover:text-foreground underline underline-offset-2"
          >
            Cookie preferences
          </button>
        </div>
        <p className="text-xs text-muted-foreground">
          &copy; {new Date().getFullYear()} PurpleToad Mail
        </p>
      </div>
      <CookiePreferences isOpen={prefsOpen} onClose={() => setPrefsOpen(false)} />
    </footer>
  )
}
